<div class="list-section-wrapper">
  <div class="list-section">
    <app-item-search
      (productSelected)="productSelected.emit($event)"
      (productRemoved)="productRemoved.emit($event)"
      style="width: 100%"
      [placeholder]="'Produkt Nummern'"
      [idTags]="selectedProductIds"
      [onlyIds]="true"></app-item-search>
    <app-empty-list-info
      style="margin-top: 30px"
      *ngIf="selectedProducts.length === 0"
      [text]="emptyListText"></app-empty-list-info>
    <div *ngIf="selectedProducts.length > 0">
      <div class="products-list">
        <app-product-card
          [listOfNeedsProduct]="true"
          class="product-card"
          *ngFor="let product of selectedProducts"
          [valid]="product.valid"
          [resident]="residentControl.value"
          [productCount]="product.quantity"
          [product]="product.product"
          (quantityChange)="updateQuantity.emit($event)"></app-product-card>
      </div>
    </div>
    <div class="buttons-container">
      <div style="width: 170px"></div>
      <app-button
        type="SAVE"
        class="add-products-button"
        text="Produkte zur Tüte hinzufügen"
        [action]="addProductsToCart.bind(this)"
        [disabled]="selectedProducts.length === 0"></app-button>
      <app-button
        type="CANCEL"
        text="Abbrechen"
        [action]="closeDialog.bind(this)"></app-button>
    </div>
  </div>
  <div class="triangle-wrapper"><div class="bottom-triangle"></div></div>
</div>
